import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppletToCatalogPluginLinksContainerModel } from "../../../../../models/aggregates/applet/applet-to-catalog-plugin-links-container.model";
import { BaseApiTemplateService, Core2Config } from "../shared";

@Injectable({
    providedIn: 'root',
})
export class AppletToCatalogPluginLinksService extends BaseApiTemplateService<AppletToCatalogPluginLinksContainerModel>{
    constructor(http: HttpClient){
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + "applet_to_catalog_plugin_links/" + BaseApiTemplateService.BACKOFFICE_EP;
        this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + "applet_to_catalog_plugin_links/" + BaseApiTemplateService.BACKOFFICE_EP;
        this.httpClient = http;
    }
}